import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { nanoid } from 'nanoid'

import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

const listTariff = [
  'beket.tariff_info.description.first',
  'beket.tariff_info.description.second',
  'beket.tariff_info.description.third',
]

export const RideRulesModal = () => {
  const { t } = useTranslation()

  return (
    <div className={s.rulesModal}>
      <p className="bold-20">{t('beket_content.ride_rules')}</p>

      <div className={s.wrapper}>
        <Paper padding={[16]}>
          <p className={clsx('regular-14', s.modalDescription)}>
            {t('beket.tariff_info.description.info')}
          </p>

          <ul className={s.list}>
            {listTariff?.map((tariff) => (
              <li
                key={nanoid()}
                className={clsx('regular-14', s.modalDescription)}
              >
                {t(tariff)}
              </li>
            ))}
          </ul>
        </Paper>
      </div>
    </div>
  )
}
